export const FETCH_EXTERNAL_MATERIAL_GROUPS = '@@externalMaterialGroup/fetch-externalMaterialGroup';
export const FETCH_EXTERNAL_MATERIAL_GROUPS_SUCCESS =
  '@@externalMaterialGroup/fetch-externalMaterialGroup-success';
export const FETCH_EXTERNAL_MATERIAL_GROUPS_FAILURE =
  '@@externalMaterialGroup/fetch-externalMaterialGroup-failure';
